import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import React from 'react';

export const useToast = () => {

    const toastId = React.useRef(null);

    const showToast = (status, message,) => {

        const defaultOptions = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            newestOnTop: false,
            closeOnClick: false,
            rtl: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
            theme: "colored",
            preventDuplicates: true
        }


        
        
        if (status === 200) {

            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.success(message, defaultOptions);
              }
            
        } else{

            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.error(message, defaultOptions);
              }

        }
    }

    return { showToast }
}
